// /pages/carrossier/FormulaireB/components/shared/RadioGroup.js
import React from "react";

const RadioGroup = ({ controle, field, label, formData, handleControleChange, productId, color = "green" }) => {
  const colorClass = color === "green" ? "text-green-600 focus:ring-green-500" : "text-orange-600 focus:ring-orange-500";
  
  try {
    return (
      <div className="grid grid-cols-4 items-center gap-4 py-3 border-b border-gray-100 hover:bg-gray-50 transition-colors">
        <label className="text-sm font-medium text-gray-900">{label}</label>
        {["O", "So", "N"].map((opt) => (
          <label key={opt} className="flex items-center gap-2 cursor-pointer">
            <input
              type="radio"
              name={`${controle}_${field}_${productId || 'default'}`}
              value={opt}
              checked={formData.controles[controle]?.[field] === opt}
              onChange={() => handleControleChange(controle, field, opt)}
              className={colorClass}
            />
            <span className="text-sm font-medium text-gray-700">{opt}</span>
          </label>
        ))}
      </div>
    );
  } catch (error) {
    console.error("❌ Erreur dans RadioGroup:", error);
    return <div className="text-red-500">Erreur d'affichage pour: {label}</div>;
  }
};

export default RadioGroup;